"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createParticipantHierarchy = exports.createHierarchy = exports.participantDifferenciators = void 0;
exports.participantDifferenciators = {
    getGroupName: () => "Everyone",
    isDifferent: (p, q) => p.labels[0] !== q.labels[0],
    useSingleChildDifferForAllGroups: false,
    children: [
        {
            debug: "classes",
            getGroupName: () => "Classes",
            isDifferent: (p, q) => p.classNum !== q.classNum,
            useSingleChildDifferForAllGroups: true,
            children: [
                {
                    debug: "classes 5-10",
                    getGroupName: (p0) => { var _a, _b; return (_b = (_a = p0.classNum) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "ERROR"; },
                    isDifferent: () => false,
                    useSingleChildDifferForAllGroups: true,
                },
            ],
        },
        {
            debug: "students",
            getGroupName: () => "Students",
            isDifferent: (s1, s2) => s1.classNum !== s2.classNum,
            useSingleChildDifferForAllGroups: true,
            children: [
                {
                    debug: "students 11-12",
                    getGroupName: (student) => { var _a, _b; return (_b = (_a = student.classNum) === null || _a === void 0 ? void 0 : _a.toString().toUpperCase()) !== null && _b !== void 0 ? _b : "ERROR"; },
                    isDifferent: (s1, s2) => s1.classChar !== s2.classChar,
                    useSingleChildDifferForAllGroups: true,
                    children: [
                        {
                            debug: "students a-e",
                            getGroupName: (student) => { var _a; return (_a = student === null || student === void 0 ? void 0 : student.classChar) !== null && _a !== void 0 ? _a : "ERROR"; },
                            isDifferent: () => false,
                            useSingleChildDifferForAllGroups: true
                        },
                    ],
                },
            ],
        },
        {
            debug: "teachers",
            getGroupName: () => "Teachers",
            isDifferent: () => false,
            useSingleChildDifferForAllGroups: true,
        },
        {
            debug: "rooms",
            getGroupName: () => "Rooms",
            isDifferent: () => false,
            useSingleChildDifferForAllGroups: true,
        },
    ],
};
const createHierarchy = (differentiators) => (currentItems) => {
    var _a;
    if (!(currentItems === null || currentItems === void 0 ? void 0 : currentItems.length)) {
        console.warn("createHierarchy: currentItems.length falsy");
        return null;
    }
    const newItemGroups = [];
    let newItems = [];
    for (let i = 0; i < currentItems.length - 1; i++) {
        const curr = currentItems[i];
        const next = currentItems[i + 1];
        const { isDifferent } = differentiators;
        newItems.push(curr);
        if (isDifferent(curr, next)) {
            newItemGroups.push(newItems);
            newItems = [];
        }
    }
    newItems.push(currentItems[currentItems.length - 1]);
    newItemGroups.push(newItems);
    if (!((_a = differentiators === null || differentiators === void 0 ? void 0 : differentiators.children) === null || _a === void 0 ? void 0 : _a.length)) {
        return {
            debug: differentiators.debug,
            groupName: differentiators.getGroupName(currentItems[0]),
            currentItems: currentItems
        };
    }
    const { children } = differentiators;
    if (children.length === 0) {
        throw new Error("differentiators.children cannot be of length 0");
    }
    let parsedChildren = [];
    const useSingleChildDifferForAllGroups = children.length === 1;
    if (useSingleChildDifferForAllGroups) {
        if (children.length !== 1) {
            parsedChildren = [{ debug: (`ERR children length must be 1 (${children.length})`) }];
        }
        else {
            parsedChildren = newItemGroups.map((group) => exports.createHierarchy(children[0])(group));
        }
    }
    else {
        if (children.length !== newItemGroups.length) {
            parsedChildren = [{ debug: `ERR children and newItemGroups lengths do not match (${children.length}, ${newItemGroups.length})` }];
        }
        else {
            parsedChildren = children.map((child, idx) => exports.createHierarchy(child)(newItemGroups[idx]));
        }
    }
    return {
        debug: differentiators.debug,
        groupName: differentiators.getGroupName(currentItems[0]),
        children: parsedChildren,
        currentItems
    };
};
exports.createHierarchy = createHierarchy;
const createParticipantHierarchyArr = exports.createHierarchy(exports.participantDifferenciators);
const createParticipantHierarchy = (currentItems) => { var _a; return (_a = createParticipantHierarchyArr(currentItems)) !== null && _a !== void 0 ? _a : null; };
exports.createParticipantHierarchy = createParticipantHierarchy;
//# sourceMappingURL=hierarchy.js.map